module.exports = __webpack_public_path__ + "3d5681e982619b3440be413250f1a567.svg";